import { classNames } from '@utils/classNames';
import { Icon } from '@components/atoms/Icon';
import { IconType } from '@src/types/IconType';
import { ParameterStatusType } from '@components/atoms/ParameterStatusType';
import { ParameterStatus } from './ParameterStatus';

type ParameterListItemRightProps = {
  isExpanded: boolean;
  status: ParameterStatusType;
  value: string;
  className?: string;
};

export const ParameterListItemRight = ({
  isExpanded,
  status,
  value,
}: ParameterListItemRightProps) => {
  return (
    <div
      className="flex flex-col items-end gap-2 xl:min-w-[180px] print:min-w-[180px]"
      data-testid="parameter-list-item-right"
    >
      <div className="flex items-center gap-2">
        {status !== 'unset' && <ParameterStatus status={status} />}
        <Icon
          type={IconType.ChevronUpThick}
          className={classNames(
            'h-4 w-5 text-grey1 transition-transform duration-150 print:hidden',
            !isExpanded && 'rotate-180',
          )}
        />
      </div>
      <span
        className={classNames(
          'xl:hidden print:hidden text-dark text-sm font-bold leading-normal font-outfit text-right h-5',
        )}
      >
        {value}
      </span>
    </div>
  );
};
